import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
import { Breadcrumb } from './breadcrumb';
import { Title } from './title';
const SectionWrapper = styled.div`
  margin: var(--layout-03) var(--layout-02) 0 var(--layout-02);
  padding: 0 var(--spacing-03);
`;
// eslint-disable-next-line react/display-name
const HeaderShell = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, className } = props;
    return /*#__PURE__*/ _jsx(SectionWrapper, {
        ref: ref,
        className: className,
        children: children
    });
});
HeaderShell.Breadcrumb = Breadcrumb;
HeaderShell.Title = Title;
HeaderShell.displayName = 'HeaderShell';
export { HeaderShell };
